import { render } from "./BadgeIcon.vue?vue&type=template&id=45f453f6&scoped=true"
import script from "./BadgeIcon.vue?vue&type=script&lang=js"
export * from "./BadgeIcon.vue?vue&type=script&lang=js"

import "./BadgeIcon.vue?vue&type=style&index=0&id=45f453f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f453f6"]])

export default __exports__